import "./CmClaimList.scss";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Tooltip
} from "@mui/material";
import CircularButton, { CustomButtonMenu, CustomLoadingButton } from "../../../components/ui/CustomButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { motion } from "framer-motion";
import { GridLoader, ScaleLoader } from "react-spinners";
import numeral from "numeral";
import moment from "moment";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { MdAdd, MdArrowBackIos, MdClose, MdOutlineAdd, MdPayments } from "react-icons/md";
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { fetchClientsBySearch, getTodaysDateWithoutTime, logData } from "../../../utils/genericFunctions";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import ExportToExcelButton from "../../../components/exportToExcelButton/ExportToExcelButton";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar";
import ClaimSearchResults from "./ClaimSearchResults.jsx";
import { AiFillFire } from "react-icons/ai";


const CmClaimList = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);
  const { currentTheme } = useSelector((state) => state.theme);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const navigate = useNavigate();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [payments, setPayments] = useState([]);
  const [claims, setClaims] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["cm-reports"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const location = useLocation();
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    param1: "",
    param2: "",
    rider_data: null
  });
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [invokedAction, setInvokedAction] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  // register new claim
  const [newClaimSearchScreen, setNewClaimSearchScreen] = useState(false);
  const [newClaimSearchTerm, setNewClaimSearchTerm] = useState("");
  const [isConfirmNewDialogOpen, setIsConfirmNewDialogOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [lossDate, setLossDate] = useState(null);
  const [intimationDate, setIntimationDate] = useState(null);
  const [selectedCover, setSelectedCover] = useState(null);
  const [selectedPolicyNo, setSelectedPolicyNo] = useState(null);
  const [description, setDescription] = useState(null);
  const [isDatesDialogOpen, setIsDatesDialogOpen] = useState(false);
  const [claimType, setClaimType] = useState(null);
  const searchFieldRef = useRef(null);
  const showBack = location.state?.showBack || "N";

  const [disableOtherFields, setDisableOtherFields] = useState(false);
  const [filterFmDate, setFilterFmDate] = useState(new Date());
  const [filterToDate, setFilterToDate] = useState(new Date());
  const [filterClaimNo, setFilterClaimNo] = useState(null);
  const [filterClient, setFilterClient] = useState(null);
  const [filterStage, setFilterStage] = useState(null);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterCurrency, setFilterCurrency] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);

  const [filterStages, setFilterStages] = useState([]);
  const [branches, setBranches] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const [filterProduct, setFilterProduct] = useState(null);
  const [products, setProducts] = useState([]);




  const fetchStages = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Claim Stages" });
      const options = res.data.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setFilterStages(options);
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };


  const fetchProducts = async () => {
    try {
      const res = await newRequest.post("/uwProduct/findAll", { lean: "Y" });
      const options = res.data.map((val) => ({
        value: val?.pr_code,
        label: val?.pr_name,
      }));
      setProducts(options);
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };


  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      let options = res.data.map((currency) => ({
        value: currency?.cur_code,
        label: currency?.cur_name,
      }));
      options.unshift({ value: "All", label: "All" });
      setCurrencies(options);
      setFilterCurrency(options[0]);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const options = ["All", "Opened", "Closed", "Rejected", "In-Court"].map((mode) => ({
        value: mode,
        label: mode,
      }));
      setStatuses(options);
      setFilterStatus({
        value: "All",
        label: "All",
      });
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };

  const handleRiskCoverSelect = (policyNo, cover) => {
    try {
      console.log(`selected policyNo  ${JSON.stringify(policyNo, null, 2)}`);
      console.log(`selected cover  ${JSON.stringify(cover, null, 2)}`);
      if (!policyNo) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`<strong>You must specify POLICY Number for risk note ${policyNo} before you can register any claim</strong>. This has to be done in underwriting!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // console.log(`selected cover  ${JSON.stringify(cover, null, 2)}`);
      setSelectedCover(cover);
      setSelectedPolicyNo(policyNo);
      setNewClaimSearchScreen(false);
      setIsDatesDialogOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewClaimSearch = async () => {
    try {
      if (!newClaimSearchTerm) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(t('pleaseEnterSearch'));
        setIsNotifyDialogOpen(true);
        return;
      }

      const res = await newRequest.post(
        "/cmClaim/searchRisk/",
        {
          search_value: newClaimSearchTerm,
          claim_type: claimType,
        }
      );
      // console.log(`setSearchResults  ${JSON.stringify(res.data, null, 2)}`);
      setSearchResults(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const setDates = () => {
    try {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // Beginning of the year
      const beginningOfYear = new Date(currentYear, 0, 1);
      beginningOfYear.setFullYear(currentYear); // Set full year again to handle leap years
      const formattedBeginningOfYear = beginningOfYear
        .toISOString()
        .split("T")[0];

      // End of the year
      const endOfYear = new Date(currentYear + 1, 0, 0);
      const formattedEndOfYear = endOfYear.toISOString().split("T")[0];

      // Beginning of the month
      const beginningOfMonth = new Date(currentYear, currentMonth, 1);
      // console.log(`Begining of the month ${beginningOfMonth}`)
      const formattedBeginningOfMonth = beginningOfMonth
        .toISOString()
        .split("T")[0];

      // End of the month
      const endOfMonth = new Date(currentYear, currentMonth + 1, 0);
      endOfMonth.setDate(endOfMonth.getDate() + 1); // Add one day to get the actual end of the month
      const formattedEndOfMonth = endOfMonth.toISOString().split("T")[0];

      // Formatting current date and one year later
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      const oneYearLater = new Date(currentDate);
      oneYearLater.setFullYear(currentYear + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split("T")[0];

      // Set these values to your state or do whatever you want with them
      setFilterFmDate(formattedBeginningOfMonth);
      setFilterToDate(formattedEndOfMonth);
    } catch (error) {
      console.log(error);
    }
  };


  const handleRegisterClaim = async () => {
    try {

      if (!lossDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter LOSS DATE!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!intimationDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter INTIMATION DATE!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!description) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter DESCRIPTION!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      const formattedLossDate = new Date(moment(lossDate).format("YYYY-MM-DD"));
      formattedLossDate.setHours(0, 0, 0, 0); // Set time to midnight

      const formattedIntimationDate = new Date(
        moment(intimationDate).format("YYYY-MM-DD")
      );
      formattedIntimationDate.setHours(0, 0, 0, 0); // Set time to midnight
      const today = new Date();

      if (formattedLossDate > today) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `Loss date ${moment(lossDate).format(
            "DD-MMM-YYYY"
          )} cannot be greater than today ${moment(
            today
          ).format("DD-MMM-YYYY")}!`
        );
        setIsNotifyDialogOpen(true);
        return;
      }


      if (formattedIntimationDate > today) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `Intimation date ${moment(intimationDate).format(
            "DD-MMM-YYYY"
          )} cannot be greater than today ${moment(
            today
          ).format("DD-MMM-YYYY")}!`
        );
        setIsNotifyDialogOpen(true);
        return;
      }
      console.log(`selectedCover  ${JSON.stringify(selectedCover, null, 2)}`);

      // console.log("formattedLossDate :", formattedLossDate);
      // console.log("formattedIntimationDate :", formattedIntimationDate);

      // Compare the dates
      if (formattedLossDate <= formattedIntimationDate) {
        console.log("formattedLossDate is equal to or less than formattedIntimationDate");
      } else {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `Loss date ${moment(lossDate).format(
            "DD-MMM-YYYY"
          )} cannot be greater than intimation date ${moment(
            intimationDate
          ).format("DD-MMM-YYYY")}!`
        );
        setIsNotifyDialogOpen(true);
        return;
      }
      console.log(`checkRiderClaim  ${JSON.stringify({
        product_code: selectedCover?.product_code,
        term_code: selectedCover?.term_code,
        policy_docid: selectedCover?.policy_docid,
        mc_code: selectedCover?.mc_code,
        sc_code: selectedCover?.sc_code,
        risk_docid: selectedCover?.risk_docid
      }, null, 2)}`);
      // check if the selected cover has a rider that should trigger another claim
      const rider = await newRequest.post(
        "/cmClaim/checkRiderClaim/",
        {
          product_code: selectedCover?.product_code,
          term_code: selectedCover?.term_code,
          policy_docid: selectedCover?.policy_docid,
          mc_code: selectedCover?.mc_code,
          sc_code: selectedCover?.sc_code,
          risk_docid: selectedCover?.risk_docid
        }
      );

      if (rider.status !== 200) {
        setIsDatesDialogOpen(false);
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(rider.data);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (rider.data === "continue") {

        const claimRef = await newRequest.post(
          "/orgNumgen/gen", { gen_type: "Claim" }
        );
        if (!claimRef) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim reference number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const claimNo = await newRequest.post(
          "/numGen/genClaimNumber",
          {
            pr_code: selectedCover.product_code,
            branch_code: selectedCover.branch_code,
            term_code: selectedCover?.term_code,
            trans_date: getTodaysDateWithoutTime()
          }
        );



        if (!claimNo) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const res = await newRequest.post(
          "/cmClaim/add/",
          {
            cm_our_ref: claimRef.data,
            cm_claim_no: claimNo.data,
            cm_policy_no: selectedPolicyNo,
            cm_policy_docid: selectedCover.policy_docid,
            cm_risk_note_no: selectedCover.risk_note_no,
            cm_risk_note_docid: selectedCover.policy_docid,
            cm_loss_date: formattedLossDate,
            cm_intimation_date: formattedIntimationDate,
            cm_description: description,
            cm_risk_code: selectedCover.rc_risk_code,
            cm_risk_docid: selectedCover.rc_risk_docid,
            cm_cover_code: selectedCover.rc_cc_code,
            cm_cover_docid: selectedCover.cover_docid,
            cm_entity_name: selectedCover.insured_name_xx,
            reserve_desc_xx: selectedCover.cover_name_xx
          }
        );

        setLossDate(null);
        setIntimationDate(null);
        setSelectedCover(null);
        setDescription(null);
        setIsDatesDialogOpen(false);
        // navigate to newly generated claim
        navigate(`/cm/${res.data._id}`, {
          state: res.data,
        });
      } else {

        const prompt_text = rider.data?.rider_text
          .replace("$$insuredName$$", selectedCover?.risk_entity_xx?.ent_name)
          .replace("$$currency$$", selectedCover?.pl_cur_code);

        setObjectToAction({
          object_id: "-1",
          action_text: prompt_text,
          rider_data: rider.data
        });
        setConfirmDialogAction("openRiderClaim");
        setIsConfirmDialogOpen(true);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openRiderClaim") {


        // console.log(`objectToAction  ${JSON.stringify(objectToAction, null, 2)}`);

        const formattedLossDate = new Date(moment(lossDate).format("YYYY-MM-DD"));
        formattedLossDate.setHours(0, 0, 0, 0); // Set time to midnight

        const formattedIntimationDate = new Date(
          moment(intimationDate).format("YYYY-MM-DD")
        );
        formattedIntimationDate.setHours(0, 0, 0, 0); // Set time to midnight
        const today = new Date();

        //  open the main claim
        const claimRef = await newRequest.post(
          "/orgNumgen/gen", { gen_type: "Claim" }
        );
        if (!claimRef) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim reference number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const claimNo = await newRequest.post(
          "/numGen/genClaimNumber",
          {
            pr_code: selectedCover.pl_product_code,
            branch_code: selectedCover.pl_biz_unit,
            term_code: selectedCover?.pl_term_code,
            trans_date: getTodaysDateWithoutTime()
          }
        );

        if (!claimNo) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const mainClaim = await newRequest.post(
          "/cmClaim/add/",
          {
            cm_our_ref: claimRef.data,
            cm_claim_no: claimNo.data,
            cm_policy_no: selectedCover.pl_no,
            cm_policy_docid: selectedCover.rc_policy_docid,
            cm_risk_note_no: selectedCover.rc_risk_note_no,
            cm_risk_note_docid: selectedCover.rc_policy_docid,
            cm_loss_date: formattedLossDate,
            cm_intimation_date: formattedIntimationDate,
            cm_description: description,
            cm_risk_code: selectedCover.rc_risk_code,
            cm_risk_docid: selectedCover.rc_risk_docid,
            cm_cover_code: selectedCover.rc_cc_code,
            cm_cover_docid: selectedCover.cover_docid,
            cm_entity_name: selectedCover.insured_name_xx,
            reserve_desc_xx: selectedCover.cover_name_xx
          }
        );
        console.log(`mainClaim  ${JSON.stringify(mainClaim, null, 2)}`);
        // end of main claim
        // open rider claim
        const claimRefRider = await newRequest.post(
          "/orgNumgen/gen", { gen_type: "Claim" }
        );
        if (!claimRefRider) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim reference number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const claimNoRider = await newRequest.post(
          "/numGen/genClaimNumber",
          {
            pr_code: selectedCover.pl_product_code,
            branch_code: selectedCover.pl_biz_unit,
            term_code: selectedCover?.pl_term_code,
            trans_date: getTodaysDateWithoutTime()
          }
        );

        if (!claimNoRider) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Claim number generation is missing`);
          setIsNotifyDialogOpen(true);
          return;
        }

        console.log(`adding related mainClaim._id ${mainClaim._id} and mainClaim.cm_claim_no ${mainClaim.cm_claim_no}`);

        await newRequest.post(
          "/cmClaim/add/",
          {
            cm_our_ref: claimRefRider.data,
            cm_claim_no: claimNoRider.data,
            cm_policy_no: selectedCover.pl_no,
            cm_policy_docid: selectedCover.rc_policy_docid,
            cm_risk_note_no: selectedCover.rc_risk_note_no,
            cm_risk_note_docid: selectedCover.rc_policy_docid,
            cm_loss_date: formattedLossDate,
            cm_intimation_date: formattedIntimationDate,
            cm_description: description,
            cm_risk_code: selectedCover.rc_risk_code,
            cm_risk_docid: selectedCover.rc_risk_docid,
            cm_cover_code: objectToAction?.rider_data?.rider_cover_code,
            cm_cover_docid: objectToAction?.rider_data?.rider_cover_docid,
            cm_entity_name: selectedCover.insured_name_xx,
            cm_related_claims: [{
              claim_docid: mainClaim?.data?._id,
              claim_no: mainClaim?.data?.cm_claim_no,
            }],
            reserve_desc_xx: objectToAction?.rider_data?.rider_cover_desc
          }
        );

        // end if rider claim
        setLossDate(null);
        setIntimationDate(null);
        setSelectedCover(null);
        setDescription(null);
        setIsDatesDialogOpen(false);
        // navigate to newly generated claim
        navigate(`/cm/${mainClaim.data._id}`, {
          state: mainClaim.data,
        });

      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };


  const filteredData = claims?.filter(
    (item) =>
      item.cm_claim_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item.cm_policy_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item.cm_description?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item.cm_our_ref?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item.cm_amount_fc
        ?.toString()
        .toLowerCase()
        .includes(searchTerm?.toLowerCase()) ||
      item.cm_cover_code?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const slicedClaimsData = filteredData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  const menus = [
    {
      _id: "home",
      title: t('home'),
    },
    {
      _id: "list",
      title: t('list'),
    },
  ];

  const handleGetClaimListing = async () => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      setIsProcessing(true);
      const res = await newRequest.post("/cmClaim/claimsListing", {
        cm_claim_no: filterClaimNo,
        date_fm: filterFmDate,
        date_to: filterToDate,
        hd_biz_unit: !filterBranch || filterBranch?.value === "All" ? "" : filterBranch?.value,
        hd_ac_no: !filterStages || filterStages.value === "All" ? "" : filterStages?.value,
        hd_status: !filterStatus || filterStatus.value === "All" ? "" : filterStatus?.value,
        hd_paying_for: !filterProduct || filterProduct.value === "All" ? "" : filterProduct?.value,
        hd_cur_code: !filterCurrency || filterCurrency?.value === "All" ? "" : filterCurrency?.value,
        hd_ent_code: !filterClient || filterClient?.value === "All" ? "" : filterClient?.value,
      });
      // console.log(`paymentsListing  ${JSON.stringify(res.data, null, 2)}`);
      if (res.data?.list) {
        setPayments(res.data?.list);
      } else {
        setPayments([]);
      }
      setIsProcessing(false);
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
    }
  };

  const fetchClaims = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/cmClaim/findAll", {
        result_limit: 5,
        cm_status: ""
      });
      setClaims(res.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearchClaims = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/cmClaim/search", { search_input: searchTerm });
        setClaims(res.data);
      } else {
        fetchClaims();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const exportConfig = [
    { key: "hd_no", label: "Payment No.", format: "s" },
    { key: "hd_type", label: "Type", format: "s" },
    { key: "hd_gl_date", label: "GL Date", format: "d" },
    { key: "hd_status", label: "Status", format: "s" },
    { key: "hd_narration", label: "Narration", format: "s" },
    { key: "hd_mode", label: "Mode", format: "s" },
    { key: "hd_ref_no", label: "Ref No", format: "s" },
    { key: "hd_paying_for", label: "Purpose", format: "s" },
    { key: "bizunit_name_xx", label: "Branch Name", format: "s" },
    { key: "hd_biz_unit", label: "Branch Code", format: "s" },
    { key: "bank_ac_no_xx", label: "Account From No", format: "s" },
    { key: "bank_ac_name_xx", label: "Account From Name", format: "s" },
    { key: "hd_chq_no", label: "Cheque No", format: "s" },
    { key: "hd_chq_date", label: "Cheque Date", format: "s" },
    { key: "client_name_xx", label: "Client Name", format: "s" },
    { key: "client_code_xx", label: "Client Code", format: "s" },
    { key: "hd_cur_code", label: "Currency", format: "s" },
    { key: "hd_cur_rate", label: "Rate", format: "n" },
    { key: "hd_fc_amount", label: "Amount FC", format: "n" },
    { key: "hd_lc_amount", label: "Amount LC", format: "n" },
    { key: "allocated_fc_amount_xx", label: "Allocated FC", format: "n" },
    { key: "allocated_lc_amount_xx", label: "Allocated LC", format: "n" },
  ];

  useEffect(() => {
    fetchClaims();
    fetchStages();

    fetchProducts();
    fetchBranches();
    fetchCurrencies();
    fetchStatuses();
    setDates();

    setSelectedMenu(menus[0]);
  }, []);

  return (
    <motion.div
      className="cm-claim-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
        >
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="cm-claim-home-main-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <div className="list-navbar-left">
                {/* <h1 className="page-title">{t('claims').toUpperCase()}</h1> */}
                <div className="cmHeroIcon">
                  <AiFillFire />
                </div>
                <div className="cmHeroTitle">{t("claims")}</div>
              </div>
              <div className="list-navbar-right">
                <div className="home-menus-wrapper">
                  {menus?.map((row, index) => (
                    <React.Fragment key={row._id}>
                      <span style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                        <CustomButtonMenu
                          className="single-menu"
                          currentButton={selectedMenu?._id === row?._id}
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              setSelectedMenu(row);
                              if (row?._id === "list") {
                                await fetchProducts();
                                await fetchStages();
                                await fetchBranches();
                                await fetchCurrencies();
                                await fetchStatuses();
                                setDates();
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          {row?.title}
                        </CustomButtonMenu>
                      </span>
                      {index < menus.length - 1 && <span className="separator-v" />}
                    </React.Fragment>
                  ))}
                </div>
                <span className="separator-v" />
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<RefreshIcon />}
                  onClick={fetchClaims}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0ea5a4"
                  tooltip={"Add new claim"}
                  endIcon={<MdAdd />}
                  onClick={() => {
                    try {
                      setNewClaimSearchScreen(true);
                      if (searchFieldRef.current) {
                        searchFieldRef.current.focus();
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {t('newClaim')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            {selectedMenu?._id === "home" && (
              <div className="cmHome">
                {/* HERO */}
                <div className="cmHero">
                  {/* <div className="cmHeroIcon">
                    <AiFillFire />
                  </div>

                  <div className="cmHeroTitle">{t("claimsHomeTitle")}</div> */}
                  <div className="cmHeroSub">
                    {t("claimsHomeDesc")}
                  </div>

                  {/* Search */}
                  <div className="homeSearch">
                    <FiSearch className="homeSearchIcon" />
                    <input
                      className="homeSearchInput"
                      type="text"
                      placeholder={`${t('search')} ${t('payments')}`}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearchClaims();
                      }}
                    />
                    {searchTerm?.length > 0 ? (
                      <MdClose
                        className="homeSearchClear"
                        onClick={() => {
                          try {
                            fetchClaims();
                            setSearchTerm("");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                    ) : (
                      <span className="homeSearchClearPlaceholder" />
                    )}
                  </div>
                </div>
                {/* GRID */}
                <div className="cmCardsGrid">
                  {slicedClaimsData?.map((claim) => {
                    const status = (claim?.cm_status || "").toUpperCase();
                    const isNew = status === "OPENED";
                    const isApproved = status === "CLOSED";
                    const isCancelled = status === "REJECTED";
                    const isValidated = status === "IN-COURT";

                    const amount = numeral(claim?.claim_reserve_amount_fc || 0).format("0,0.00");
                    const paid = numeral(claim?.claim_paid_amount_fc || 0).format("0,0.00");
                    const isFullyPaid =
                      Number(claim?.claim_paid_amount_fc || 0) >= Number(claim?.claim_reserve_amount_fc || 0) &&
                      Number(claim?.claim_reserve_amount_fc || 0) > 0;

                    return (
                      <div
                        key={claim?._id}
                        className={`cmCard ${isNew ? "isNew" : ""} ${isApproved ? "isApproved" : ""} ${isCancelled ? "isCancelled" : ""}`}
                        onClick={() => navigate(`/cm/${claim?._id}`, { state: claim })}
                      >
                        {/* top */}
                        <div className="cmCardTop">
                          <InitialsAvatar
                            name={claim?.policy_xx?.insured_details_xx?.ent_name || ""}
                            size={42}
                            currentTheme={currentTheme}
                          />

                          <div className="cmCardTopMeta">
                            <div className="cmCardNo">{claim?.cm_claim_no || claim?.cm_our_ref}</div>
                            <div className="cmCardName">{claim?.policy_xx?.insured_details_xx?.ent_name}</div>
                            <div className="cmCardTiny">{claim?.policy_xx?.insured_details_xx?.ent_type} </div>
                          </div>

                          <div className="cmCardTopRight">
                            <span className={`cmStatusPill ${status}`}>
                              {status || "STATUS"}
                            </span>
                          </div>
                        </div>

                        {/* divider */}
                        <div className="cmDivider" />

                        {/* amount block */}
                        <div className="cmAmountRow">
                          <div className="cmAmountLabel">
                            <div className="cmAmountTitle">{`Amount [${claim?.policy_xx?.pl_cur_code || ""}]`}</div>
                          </div>

                          <div className="cmAmountValueWrap">
                            <div className={`cmAmountValue ${isCancelled ? "neg" : ""}`}>
                              {amount}
                            </div>
                            <div className={`cmAmountHint ${isFullyPaid ? "ok" : ""}`}>
                              {isCancelled ? "VOIDED" : isFullyPaid ? t('fullyPaid').toUpperCase() : t('reserved').toUpperCase()}
                            </div>
                          </div>
                        </div>

                        {/* meta row */}
                        <div className="cmMetaRow">
                          <div className="cmMetaCol" style={{ flex: "1.5" }}>
                            <div className="cmMetaLabel">{t('stage').toUpperCase()}</div>
                            <div className="cmMetaValue">{claim?.cm_stage || "-"}</div>
                          </div>

                          <div className="cmMetaCol" style={{ flex: "1", textAlign: "right" }}>
                            <div className="cmMetaLabel">{t('lossDate').toUpperCase()}</div>
                            <div className="cmMetaValue">
                              {claim?.cm_loss_date ? moment(claim?.cm_loss_date).format("DD-MMM-YYYY") : "-"}
                            </div>
                          </div>
                        </div>

                        {/* footer */}
                        <div className="cmCardFooter">
                          <div className="cmFooterLeft">
                            {/* <div className="cmOrgDot" /> */}
                            <InitialsAvatar
                              name={claim?.updated_by_name_xx}
                              size={20}
                              currentTheme={currentTheme}
                            />
                            <div className="cmOrgName">{claim?.updated_by_name_xx || "Bima Go"}</div>
                          </div>

                          <div className="cmFooterRight">
                            <div className="cmFooterTiny">{claim?.time_ago_xx || ""}</div>
                            <div className="cmFooterTiny">{`Paid ${claim?.claim_paid_amount_fc}`}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Create New Claim Tile */}
                  <div
                    className="cmCardCreate"
                    onClick={() => {
                      try {
                        setNewClaimSearchScreen(true);
                        if (searchFieldRef.current) {
                          searchFieldRef.current.focus();
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <div className="cmCreatePlus">+</div>
                    <div className="cmCreateText">{t('createNewClaim')}</div>
                  </div>
                </div>

                {/* Floating help button (keeps your existing help overlay logic) */}
                <div className="list-footer">
                  <button className="overlay-button" onClick={() => setIsOverlayOpen(true)}>
                    {t('how')}
                  </button>
                </div>
              </div>
            )}
            {selectedMenu?._id === "list" &&
              <motion.div
                className="filter-wrapper"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1 } }}
                exit={{ opacity: 0, transition: { duration: 1 } }}
              >
                <ExpandableComponent
                  title={<h3 className="normal-title" style={{ alignSelf: "center" }}>{t('pleaseEnterSearch')}</h3>}
                  subtitle={""}
                  defaultExpanded={true}
                >
                  <div className="content-wrapper-selection">
                    <div className="filter">
                      <div className="left">
                        <div className="input-item-with-label">
                          <label
                            htmlFor="fm_date"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('from').toUpperCase()}
                          </label>
                          <input
                            id="fm_date"
                            name="fm_date"
                            type="date"
                            placeholder={t('from').toUpperCase()}
                            value={filterFmDate}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              if (e.target.value) {
                                const formattedFmDate = moment(e.target.value).format("YYYY-MM-DD");
                                setFilterFmDate(formattedFmDate);
                              }
                            }}
                            disabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label
                            htmlFor="to_date"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('to').toUpperCase()}
                          </label>
                          <input
                            id="to_date"
                            name="to_date"
                            type="date"
                            placeholder={t('to').toUpperCase()}
                            value={filterToDate}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              if (e.target.value) {
                                const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
                                setFilterToDate(formattedToDate);
                              }
                            }}
                            disabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label
                            htmlFor="filter_claim_no"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('claimNo').toUpperCase()}
                          </label>
                          <input
                            id="filter_claim_no"
                            name="filter_claim_no"
                            type="text"
                            placeholder={t('claimNo').toUpperCase()}
                            value={filterClaimNo}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              try {
                                setFilterClaimNo(e.target.value);
                                if (e.target.value) {
                                  setDisableOtherFields(true);
                                } else {
                                  setDisableOtherFields(false);
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') handleGetClaimListing();
                            }}
                          />
                        </div>
                      </div>
                      <div className="center">
                        <div className="input-item-with-label">
                          <label htmlFor="product_code" style={{ width: "130px" }}>
                            {t('stage').toUpperCase()}
                          </label>
                          <Select
                            id="hd_ac_no"
                            name="hd_ac_no"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterStage}
                            onChange={(selectedOption) => setFilterStage(selectedOption)}
                            options={filterStages}
                            isSearchable={true}
                            isClearable
                            placeholder={t('stage').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="product" style={{ width: "130px" }}>
                            {t('product').toUpperCase()}
                          </label>
                          <Select
                            id="product"
                            name="product"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterProduct}
                            onChange={(selectedOption) => setFilterProduct(selectedOption)}
                            options={products}
                            isSearchable={true}
                            isClearable
                            placeholder={t('product').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="client" style={{ width: "130px" }}>
                            {t('client').toUpperCase()}
                          </label>
                          <AsyncSelect
                            id="client"
                            name="client"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterClient}
                            onChange={(selectedOption) => setFilterClient(selectedOption)}
                            loadOptions={fetchClientsBySearch}
                            isSearchable={true}
                            isClearable
                            placeholder={t('client').toUpperCase()}
                            noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                      </div>
                      <div className="right">
                        <div className="input-item-with-label biz_unit">
                          <label htmlFor="biz_unit" style={{ width: "100px" }}>
                            {t('bizUnit').toUpperCase()}
                          </label>
                          <Select
                            id="biz_unit"
                            name="biz_unit"
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterBranch}
                            onChange={(selectedOption) => setFilterBranch(selectedOption)}
                            options={branches}
                            isSearchable={true}
                            placeholder={t('bizUnit').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="currency_code" style={{ width: "100px" }}>
                            {t('currency').toUpperCase()}
                          </label>
                          <Select
                            id="currency_code"
                            name="currency_code"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterCurrency}
                            onChange={(selectedOption) => setFilterCurrency(selectedOption)}
                            options={currencies}
                            isSearchable={true}
                            placeholder={t('currency').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="status" style={{ width: "100px" }}>
                            {t('status').toUpperCase()}
                          </label>
                          <Select
                            id="status"
                            name="status"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterStatus}
                            onChange={(selectedOption) => setFilterStatus(selectedOption)}
                            options={statuses}
                            isSearchable={true}
                            placeholder={t('status').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", margin: "5px 0px" }}>
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        endIcon={<PageviewOutlinedIcon />}
                        onClick={handleGetClaimListing}
                      >
                        {t('run').toUpperCase()}
                      </CustomLoadingButton>
                    </div>
                  </div>
                </ExpandableComponent>
                <div className="filter-wrapper-results">
                  <div className="results-wrapper">
                    <div className="results-wrapper-navbar">
                      <div className="navbar-left">
                        <div className="search-input-wrapper" style={{ width: "90%" }}>
                          <FiSearch className="search-input-icon" />
                          <input
                            className="search-input"
                            type="text"
                            placeholder={t('search')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          {searchTerm.length > 0 && (
                            <MdClose
                              onClick={() => setSearchTerm("")}
                              className="search-input-icon"
                            />
                          )}
                        </div>
                      </div>
                      <div className="navbar-right">
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            borderRadiusType="both"
                            variant="tint"
                            color="#0f766e5d"
                            endIcon={<RefreshIcon />}
                            onClick={handleGetClaimListing}
                          >
                            {t('refresh')}
                          </CustomLoadingButton>
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            borderRadiusType="both"
                            variant="tint"
                            color="#2563EB"
                            tooltip="Run claims reports"
                            endIcon={<IoDocumentTextSharp />}
                            onClick={() => setReportsDialogOpen(true)}>
                            {t('reports')}
                          </CustomLoadingButton>
                          {filteredData?.length > 0 &&
                            <ExportToExcelButton
                              data={filteredData}
                              exportConfig={exportConfig}
                              fileName="Claims.xlsx"
                              currentTheme={currentTheme}
                              borderRadiusType="right"
                            />}
                        </div>
                      </div>
                    </div>
                    <div className="table-content">
                      {slicedClaimsData?.length > 0 &&
                        <div className="table-content">
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                            className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableBody className="tablebody">
                                {slicedClaimsData?.map((claim, index) => (
                                  <TableRow
                                    key={claim._id}
                                    className="tablerow"
                                    onClick={() => navigate(`/cm/${claim._id}`)}
                                  >
                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                      {page * rowsPerPage + index + 1}
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                      <span className="sub-title">{claim?.cm_claim_no} </span>
                                      <span className="sub-title soft xrsmall"> {claim?.cm_our_ref}</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ flexDirection: "column", width: "auto" }}>
                                      <span className="sub-title">{`${claim?.policy_xx?.insured_details_xx?.ent_name}`}</span>
                                      <span className="sub-title soft xrsmall">{`# ${claim?.policy_xx?.insured_details_xx?.ent_code}`}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                      <span className="sub-title boldsmall"><span className="sub-title xrsmall" style={{ textAlign: "right", fontWeight: "bold", fontSize: "10px", color: "#f44336" }}>[{claim?.policy_xx?.pl_cur_code}]</span> : {`${t('paid')} ${numeral(claim?.cm_amount_fc).format("0,0.00")}`}</span>
                                      <span className="sub-title boldsmall">{`${t('allocatpaided')} ${numeral(claim?.claim_paid_amount_fc).format("0,0.00")}`}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                      <span className="sub-title">{claim?.cm_stage}</span>
                                      <span className="sub-title"> {claim?.policy_xx?.bizunit_name_xx}</span>
                                    </TableCell>
                                    <TableCell className="table-cell center" style={{ maxWidth: "120px" }}>
                                      <span> {moment(claim?.cm_loss_date).format("DD-MMM-YYYY")}</span>
                                      <span className={`status small ${claim?.cm_status}`}> {claim?.cm_status}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                      <WorkedOnBy name={claim?.updated_by_name_xx} photoUrl={claim?.updated_by_photo_url_xx} time_ago_xx={claim?.time_ago_xx} showTitle={false} />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            {filteredData.length > rowsPerPage
                              && <TablePagination
                                rowsPerPageOptions={[5]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                component="div"
                                count={filteredData.length}
                                page={page}
                                onPageChange={handleChangePage}
                              />}
                          </TableContainer>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </motion.div>}
          </motion.div>
          {isOverlayOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span>{t('help')}</span>
                  <CircularButton
                    onClick={() => {
                      try {
                        setIsOverlayOpen(false);
                      } catch (error) {
                        console.log(error);
                      }
                    }} icon={<IoClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <VideoPlayer videoUrl="https://www.youtube.com/embed/PPCfDe8TfJQ" />
                </div>
                <div className="overlay-actions">
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docType: "AllClaims",
                  docId: "1",
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: "",
                  filters: {
                    cm_claim_no: filterClaimNo,
                    date_fm: filterFmDate,
                    date_to: filterToDate,
                    cm_biz_unit: !filterBranch || filterBranch?.value === "All" ? "" : filterBranch?.value,
                    cm_ac_no: !filterStages || filterStages.value === "All" ? "" : filterStages?.value,
                    cm_status: !filterStatus || filterStatus.value === "All" ? "" : filterStatus?.value,
                    hd_paying_for: !filterProduct || filterProduct.value === "All" ? "" : filterProduct?.value,
                    hd_cur_code: !filterCurrency || filterCurrency?.value === "All" ? "" : filterCurrency?.value,
                    hd_ent_code: !filterClient || filterClient?.value === "All" ? "" : filterClient?.value,
                  }
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* register new claim */}
      {newClaimSearchScreen && (
        <motion.div
          className="new-claim-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="new-claim-wrapper" style={{ minWidth: "700px" }}>
            <div className="new-claim-navbar">
              <div className="homeSearch" style={{ width: "80%" }}>
                <FiSearch className="homeSearchIcon" />
                <input
                  className="homeSearchInput"
                  type="text"
                  placeholder={t('claimSearchPlaceholder')}
                  value={newClaimSearchTerm}
                  onChange={(e) => setNewClaimSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleNewClaimSearch();
                  }}
                />
                {newClaimSearchTerm?.length > 0 ? (
                  <MdClose
                    className="homeSearchClear"
                    onClick={async () => {
                      try {
                        setSearchResults([]);
                        setNewClaimSearchTerm("");
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                ) : (
                  <span className="homeSearchClearPlaceholder" />
                )}
              </div>

              <CircularButton currentTheme={currentTheme} onClick={() => {
                try {
                  setSearchResults([]);
                  setNewClaimSearchTerm("");
                  setNewClaimSearchScreen(false);
                } catch (error) {
                  console.log(error);
                }
              }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            {newClaimSearchTerm.length > 0 &&
              searchResults?.length > 0 &&
              <div className="new-claim-content">
                <span className="sub-title">{t('searchResults').toUpperCase()}</span>
                {searchResults?.length > 10 ?
                  <span> {t('refineSearch', { param1: searchResults?.length })} </span>
                  :
                  <ClaimSearchResults risks={searchResults} handleRiskCoverSelect={handleRiskCoverSelect} claimType={claimType}
                  />}
              </div>}
          </div>
        </motion.div>
      )}
      {/* dates dialog */}
      {isDatesDialogOpen && (
        <motion.div
          className="new-claim-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="new-claim-wrapper">
            <div className="new-claim-navbar">
              <span>{t('enterDates').toUpperCase()}</span>
              <span
                onClick={() => {
                  try {
                    setIsDatesDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <Tooltip title="Close" placement="right">
                  <MdClose
                    style={{
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                  />
                </Tooltip>
              </span>
            </div>
            <div className="new-claim-content">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="input-item-with-label">
                  <label
                    htmlFor="loss_date"
                    className="form-dropdown-label"
                    style={{ width: "120px" }}
                  >
                    {t('lossDate').toUpperCase()}
                  </label>
                  <input
                    id="loss_date"
                    name="loss_date"
                    type="date"
                    placeholder={t('lossDate').toUpperCase()}
                    value={lossDate}
                    className="form-input-item"
                    style={{ width: "170px" }}
                    onChange={(e) => setLossDate(e.target.value)}
                  />
                </div>
                <div className="input-item-with-label">
                  <label
                    htmlFor="intimation_date"
                    className="form-dropdown-label"
                    style={{ width: "120px" }}
                  >
                    {t('intimation').toUpperCase()}
                  </label>
                  <input
                    id="intimation_date"
                    name="intimation_date"
                    type="date"
                    placeholder={t('intimation').toUpperCase()}
                    value={intimationDate}
                    className="form-input-item"
                    style={{ width: "170px" }}
                    onChange={(e) => setIntimationDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="description"
                  className="form-dropdown-label"
                  style={{ alignSelf: "flex-start", width: "120px" }}
                >
                  {t('description').toUpperCase()}
                </label>
                <textarea
                  id="description"
                  name="description"
                  type="text"
                  placeholder={t('descriptionOfLoss').toUpperCase()}
                  value={description}
                  className="form-input-item"
                  rows={3}
                  style={{ width: "465px" }}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
            <div className="new-claim-action-withnote">
              <span>{t('registerNote')}</span>
              <CustomLoadingButton currentTheme={currentTheme} onClick={handleRegisterClaim}>
                {t('register').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default CmClaimList;
